import React from 'react'
import DefaultModal from '../modal/DefaultModal/DefaultModal'
import { formatKwikMessageContent, formatTimestampLabel } from '../../services/scout'
import { getSearchConversationTitle, getSearchResultSubtitle, highlightQuery } from './SearchHighlight'

const SearchResultsModal = ({
	open,
	searchValue,
	searchResultsLoading,
	searchFeedback,
	searchResults,
	onClose,
	onOpenSearchConversation,
}) => {
	return (
		<>
			{open ? (
				<DefaultModal
					handleClose={onClose}
					title={`Resultados da busca para "${searchValue}"`}
					maxWidth="md"
				>
					{searchResultsLoading ? <div className="scout-search-results__status">Buscando mensagens...</div> : null}
					{!searchResultsLoading && searchFeedback ? <div className="scout-search-results__status">{searchFeedback}</div> : null}
					{!searchResultsLoading && !searchFeedback ? (
						<div className="scout-search-results">
							{searchResults.map((result) => (
								<section key={result.id} className="scout-search-result-card">
									<div className="scout-search-result-card__header">
										<div>
										<h3>{highlightQuery(getSearchConversationTitle(result.conversationName), searchValue)}</h3>
											{getSearchResultSubtitle(result) ? <p>{getSearchResultSubtitle(result)}</p> : null}
										</div>
										<button
											type="button"
											className="scout-search-result-card__action"
											onClick={() => onOpenSearchConversation(result, result.messages?.[0] || null)}
										>
											Abrir conversa
										</button>
									</div>
									<div className="scout-search-result-card__messages">
										{result.messages.map((message, index) => (
											<article
												key={`${result.id}-message-${index}`}
												className={message?.fromMe ? 'scout-search-message scout-search-message--outbound' : 'scout-search-message'}
												onClick={() => onOpenSearchConversation(result, message)}
												style={{ cursor: 'pointer' }}
											>
													<div className="scout-search-message__meta">
														<strong>{message?.pushName || message?.sender || (message?.fromMe ? 'Você' : 'Contato')}</strong>
														<span>{formatTimestampLabel(message?.timestamp || message?.messageTimestamp || message?.iso_time)}</span>
													</div>
													<p>{highlightQuery(formatKwikMessageContent(message), searchValue)}</p>
												</article>
											))}
										</div>
								</section>
							))}
						</div>
					) : null}
				</DefaultModal>
			) : null}
		</>
	)
}

export default SearchResultsModal
